import AboutUs from "../components/About/AboutUs";
import { Mission } from "../components/About/Mission";
import WhyPublish from "../components/About/WhyPublish";


export default function AboutPage() {
  return <>
    <AboutUs />
    <Mission />
    <WhyPublish />
  </>;
}
